import * as React from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../berry/layout/index.jsx';
import ThemeCustomization from 'src/berry/themes';
import { UserDeffer } from 'src/context/user.jsx';
import { JSONMapProvider, JSONMapDeffer } from 'src/context/json_map.jsx';
import { JSONTimelineProvider, JSONTimelineDeffer } from 'src/context/json_timeline.jsx';
import { ModalsProvider } from 'src/context/modals.jsx';

import Modals from 'src/controllers/modals.jsx';

const Dashboard = () => {
	const { app_uid } = useParams();
	const has_app_uid = !!app_uid;
	const is_timeline_app = ['ama_tml_app', 'ama_tml_web'].includes(app_uid);

	return (
		<ThemeCustomization>
			<UserDeffer>
				{is_timeline_app ? (
					<JSONTimelineProvider>
						{has_app_uid ? (
							<JSONTimelineDeffer>
								<ModalsProvider>
									<Modals />
									<Layout />
								</ModalsProvider>
							</JSONTimelineDeffer>
						) : (
							<ModalsProvider>
								<Modals />
								<Layout />
							</ModalsProvider>
						)}
					</JSONTimelineProvider>
				) : (
					<JSONMapProvider>
						{has_app_uid ? (
							<JSONMapDeffer>
								<ModalsProvider>
									<Modals />
									<Layout />
								</ModalsProvider>
							</JSONMapDeffer>
						) : (
							<ModalsProvider>
								<Modals />
								<Layout />
							</ModalsProvider>
						)}
					</JSONMapProvider>
				)}
			</UserDeffer>
		</ThemeCustomization>
	);
};

export default Dashboard;
